import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_13 = {
  key: 0,
  href: "#"
}
const _hoisted_14 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_15 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_16 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_19 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_20 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_21 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_22 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_23 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_24 = { class: "d-flex my-4" }
const _hoisted_25 = {
  href: "#",
  class: "btn btn-sm btn-light me-2",
  id: "kt_user_follow_button"
}
const _hoisted_26 = { class: "svg-icon svg-icon-3 d-none" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-sm btn-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_offer_a_deal"
}, "Hire Me", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "me-0" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
    "data-kt-menu-trigger": "click",
    "data-kt-menu-placement": "bottom-end",
    "data-kt-menu-flip": "top-end"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 pe-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between w-100 mt-auto mb-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-6 text-gray-400" }, "Profile Compleation"),
      /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "50%")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "h-5px mx-3 w-100 bg-light mb-3" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "bg-success rounded h-5px",
        role: "progressbar",
        style: {"width":"50%"},
        "aria-valuenow": "50",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      })
    ])
  ])
], -1)
const _hoisted_30 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_31 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_32 = { class: "nav-item" }
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = { class: "nav-item" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.userDetail.avatar,
                alt: "image"
              }, null, 8, _hoisted_6),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.userDetail.fullName), 1),
                  (_ctx.userDetail.emailVerifiedAt)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" Chức vụ: " + _toDisplayString(_ctx.userDetail.positionId), 1)
                  ]),
                  _createElementVNode("a", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _createTextVNode(" Phòng ban: " + _toDisplayString(_ctx.userDetail.departmentId), 1)
                  ]),
                  _createElementVNode("a", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com005.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.userDetail.phone), 1)
                  ]),
                  _createElementVNode("a", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.userDetail.email ? _ctx.userDetail.email : '-'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr012.svg" })
                  ]),
                  _createTextVNode(" Follow ")
                ]),
                _hoisted_27,
                _hoisted_28
              ])
            ]),
            _hoisted_29
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("ul", _hoisted_31, [
            _createElementVNode("li", _hoisted_32, [
              _createVNode(_component_router_link, {
                to: "/crafted/pages/profile/overview",
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Thông tin chung ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_33, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: "/crafted/pages/profile/projects",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Projects ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_34, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: "/crafted/pages/profile/campaigns",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Campaigns ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_35, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: "/crafted/pages/profile/documents",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Documents ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_36, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: "/crafted/pages/profile/connections",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Connections ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_37, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: "/crafted/pages/profile/activity",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Activity ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}